import React from 'react';

import { FormattedNumber } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Text, xcss } from '@atlaskit/primitives';

const styles = xcss({
	marginLeft: 'auto',
});
export const ResultCount = (option: {
	count?: number;
	isSelected: boolean;
	resultCountLimit?: number;
}): React.JSX.Element => {
	const { count, isSelected, resultCountLimit } = option;
	if (count === undefined) {
		return <></>;
	}
	const countExceedsLimit = !!(resultCountLimit && count >= resultCountLimit);
	return (
		<Box xcss={styles}>
			<Text color={isSelected ? 'color.text.accent.blue' : 'color.text.subtlest'} size="small">
				<FormattedNumber
					value={countExceedsLimit ? resultCountLimit : count}
					notation={'compact'}
				/>
				{countExceedsLimit && <>+</>}
			</Text>
		</Box>
	);
};
